// webapp/src/AppLayout.js
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { supabase } from './supabase';
import { useAuth } from './AuthContext';
import AppHeader from './AppHeader';
import { classifyError, trackEvent } from './analytics';
import { isFocusedStudio } from './appNavigation';
import './Studio.css';
import {clearPendingFile} from './pendingFile.mjs';
import {clearAuthFlow} from './authFlowContext';

function AppLayout() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      trackEvent('logout_attempt', { source: 'app_header' });
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      clearPendingFile();clearPendingFile('audio_tool_reload');clearAuthFlow();
      navigate("/login");
    } catch (error) {
      trackEvent('logout_error', { source: 'app_header', error_type: classifyError(error) });
      console.error("Sign out error:", error);
    }
  };

  return (
    <div className={`app-container${isFocusedStudio() ? ' app-container--studio' : ''}`}>
      {!isFocusedStudio() && <AppHeader currentUser={currentUser} onSignOut={handleSignOut} />}
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;
